// global.js
export default {
  ws: {},
  setWs: function (newWs) {
    this.ws = newWs
  }

}


// WEBPACK FOOTER //
// ./src/utils/global.js